
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';
import Loader from 'components/Loader';
import { PrivacyWrapper } from './styles';
import { CommonGlassContainer, H1Head } from 'assets/styles/globalStyles';
import Footer from 'components/Footer';

const Policy = (props: { id: any; }) => {
  const { id } = props;
  const { currentLang } = useSelector((store: any) => store.commonData);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const { t } = useTranslation();

  const fetchContent = async () => {
    setLoading(true)
    const res = await fetchData(restAPIs.getEVPages(currentLang?.id, id));
    setData(res.page);
    setLoading(false)
  };


  useEffect(() => {
    window.scrollTo(0, 0);
    fetchContent();
  }, [currentLang, id]);

  if (isLoading) return <Loader />;

  return (


    <PrivacyWrapper>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <H1Head style={{ color: '#fff', marginBottom: '20px' }}>{data?.name}</H1Head>
                            <CommonGlassContainer className="___comn_txt">
                                <div className='row'>
                                  <div className='col-md-12'>
                                                <p dangerouslySetInnerHTML={{ __html: data?.description }} style={{ lineHeight: 1.7 }}></p>
                                            </div>
                                </div>
                            </CommonGlassContainer>
                        </div>
                    </div>
                </div>

                <Footer />

            </PrivacyWrapper>


  );
};

export default Policy;
